{
  "name": "idea-financial-web",
  "version": "4.16.1",
  "scripts": {
    "// === DEVELOPMENT ===": "",
    "start": "npm run start:web",
    "start:no-open": "npm run start:web:no-open",
    "start:web": "run-s build:common:prod serve:all",
    "start:web:no-open": "run-s build:common:prod serve:all:no-open",
    "start:with-mobile": "run-p -l adb:watch start:web",
    "adb:pair": "powershell -ExecutionPolicy Bypass -File .\\scripts\\setup-android-adb-reverse.ps1 -Pair -PairTimeoutSeconds 45 -AllowMissingAdb",
    "adb:status": "powershell -ExecutionPolicy Bypass -File .\\scripts\\setup-android-adb-reverse.ps1 -Status -AllowMissingAdb",
    "adb:watch": "powershell -ExecutionPolicy Bypass -File .\\scripts\\setup-android-adb-reverse.ps1 -Watch -AllowMissingAdb -AllowMissingDevice -WatchIntervalSeconds 5",
    "dev:portal": "run-s build:common && run-p -l build:common:watch serve:portal serve:sso serve:sso:backend",
    "dev:my": "run-s build:common && run-p -l build:common:watch serve:portal serve:my serve:sso serve:sso:backend",
    "dev:backoffice": "run-s build:common && run-p -l build:common:watch serve:backoffice",
    "dev:application": "run-s build:common && run-p -l build:common:watch serve:application",
    "dev:sso": "run-s build:common && run-p -l build:common:watch serve:sso serve:sso:backend",
    "dev:partner": "run-s build:common && run-p -l build:common:watch serve:partner",
    "// === SERVE ===": "",
    "serve:all": "run-p -l serve:portal serve:my serve:backoffice serve:application serve:sso serve:partner serve:sso:backend",
    "serve:all:no-open": "run-p -l serve:portal:no-open serve:my:no-open serve:backoffice:no-open serve:application:no-open serve:sso:no-open serve:partner:no-open serve:sso:backend",
    "serve:portal": "ng serve portal --host 0.0.0.0",
    "serve:portal:no-open": "ng serve portal --open false --host 0.0.0.0",
    "serve:my": "ng serve my --host 0.0.0.0",
    "serve:my:no-open": "ng serve my --open false --host 0.0.0.0",
    "serve:backoffice": "ng serve backoffice --host 0.0.0.0",
    "serve:backoffice:no-open": "ng serve backoffice --open false --host 0.0.0.0",
    "serve:application": "ng serve application --host 0.0.0.0",
    "serve:application:no-open": "ng serve application --open false --host 0.0.0.0",
    "serve:sso": "ng serve sso --host 0.0.0.0",
    "serve:sso:no-open": "ng serve sso --open false --host 0.0.0.0",
    "serve:partner": "ng serve partner --host 0.0.0.0",
    "serve:partner:no-open": "ng serve partner --open false --host 0.0.0.0",
    "serve:sso:backend": "cd ..\\ModularMonolith\\src\\Bootstrapper\\ModularMonolith.Bootstrapper && dotnet run",
    "// === BUILD ===": "",
    "build": "run-s clean build:web-init build:common:prod build:apps:prod",
    "build:application": "ng build application",
    "build:apps:prod": "run-p -l build:prod:*",
    "build:backoffice": "ng build backoffice",
    "build:browser-detection": "node scripts/browser-detection/build-browser-detection.js",
    "build:common": "ng build common",
    "build:common:prod": "ng build common --configuration production",
    "build:common:watch": "ng build common --watch",
    "build:my": "ng build my",
    "build:partner": "ng build partner",
    "build:portal": "ng build portal",
    "build:prod:application": "ng build application --configuration production",
    "build:prod:backoffice": "ng build backoffice --configuration production",
    "build:prod:my": "ng build my --configuration production",
    "build:prod:partner": "ng build partner --configuration production",
    "build:prod:portal": "ng build portal --configuration production",
    "build:prod:sso": "ng build sso --configuration production",
    "build:sso": "ng build sso",
    "build:web-init": "node scripts/web-init/build-web-init.js",
    "// === TEST ===": "",
    "test": "run-p -l test:common test:portal test:partner test:browser-detection",
    "test:application": "ng test application --watch=false --browsers=ChromeHeadless --code-coverage",
    "test:backoffice": "ng test backoffice --watch=false --browsers=ChromeHeadless --code-coverage",
    "test:browser-detection": "vitest run --config scripts/browser-detection/vitest.config.js --coverage",
    "test:ci": "run-p -l test:ci:*",
    "test:ci:application": "ng test application --watch=false --browsers=ChromeHeadless --code-coverage",
    "test:ci:backoffice": "ng test backoffice --watch=false --browsers=ChromeHeadless --code-coverage",
    "test:ci:common": "ng test common --watch=false --browsers=ChromeHeadless --code-coverage",
    "test:ci:my": "ng test my --watch=false --browsers=ChromeHeadless --code-coverage",
    "test:ci:partner": "ng test partner --watch=false --browsers=ChromeHeadless --code-coverage",
    "test:ci:portal": "ng test portal --watch=false --browsers=ChromeHeadless --code-coverage",
    "test:ci:sso": "ng test sso --watch=false --browsers=ChromeHeadless --code-coverage",
    "test:common": "ng test common --watch=false --browsers=ChromeHeadless --code-coverage",
    "test:my": "ng test my --watch=false --browsers=ChromeHeadless --code-coverage",
    "test:partner": "ng test partner --watch=false --browsers=ChromeHeadless --code-coverage",
    "test:portal": "ng test portal --watch=false --browsers=ChromeHeadless --code-coverage",
    "test:sso": "ng test sso --watch=false --browsers=ChromeHeadless --code-coverage",
    "// === MAINTENANCE ===": "",
    "clean": "rimraf dist .angular && npm cache clean --force",
    "deps:reset": "rimraf node_modules package-lock.json",
    "format": "prettier --write \"projects/**/*.{ts,html,scss,json}\"",
    "format:check": "prettier --check \"projects/**/*.{ts,html,scss,json}\"",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "ng": "ng",
    "postinstall": "npm cache verify",
    "reinstall": "npm run clean && npm run deps:reset && npm install",
    "// === UTILITIES ===": "",
    "sanity": "run-s build test start:no-open",
    "sanity:full": "run-s reinstall build test start:no-open",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org idea-financial --project partner ./dist && sentry-cli sourcemaps upload --org idea-financial --project partner ./dist"
  },
  "private": true,
  "overrides": {
    "rollup": "npm:@rollup/wasm-node@4.54.0"
  },
  "dependencies": {
    "@angular/animations": "^20.3.15",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.15",
    "@angular/compiler": "^20.3.15",
    "@angular/core": "^20.3.15",
    "@angular/forms": "^20.3.15",
    "@angular/localize": "^20.3.15",
    "@angular/material": "^20.2.14",
    "@angular/material-moment-adapter": "^20.2.14",
    "@angular/platform-browser": "^20.3.15",
    "@angular/platform-browser-dynamic": "^20.3.15",
    "@angular/router": "^20.3.15",
    "@ngbracket/ngx-layout": "^20.0.1",
    "@ngneat/until-destroy": "^10.0.0",
    "@sentry/angular": "^10.30.0",
    "@sentry/cli": "^2.58.3",
    "@stoplight/elements": "^9.0.13",
    "@swimlane/ngx-charts": "^23.1.0",
    "@uppy/angular": "1.1.0",
    "@uppy/core": "^5.2.0",
    "@uppy/dashboard": "^5.1.0",
    "@uppy/provider-views": "^5.2.1",
    "@uppy/status-bar": "^5.1.0",
    "@uppy/store-default": "5.0.0",
    "@uppy/thumbnail-generator": "^5.1.0",
    "@uppy/utils": "^7.1.4",
    "@uppy/xhr-upload": "^5.1.1",
    "angularx-qrcode": "^20.0.0",
    "buffer": "^6.0.3",
    "chart.js": "^4.5.1",
    "core-js": "^3.47.0",
    "d3-shape": "3.2.0",
    "deep-object-diff": "^1.1.9",
    "dom-confetti": "^0.2.2",
    "jwt-decode": "^4.0.0",
    "lodash": "^4.17.21",
    "moment": "^2.30.1",
    "ng2-charts": "^8.0.0",
    "ngx-cookie-service": "^20.1.1",
    "ngx-countdown": "^20.0.0",
    "ngx-google-maps-places-api": "^20.4.0",
    "ngx-google-maps-places-autocomplete": "^20.4.0",
    "ngx-mask": "^20.0.3",
    "ngx-mat-select-search": "^8.0.4",
    "ngx-skeleton-loader": "^11.3.0",
    "ngx-toastr": "^19.1.0",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "uuid": "^13.0.0",
    "xlsx": "0.18.5",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^19.8.1",
    "@angular-eslint/eslint-plugin": "^19.8.1",
    "@angular-eslint/eslint-plugin-template": "^19.8.1",
    "@angular-eslint/schematics": "^19.8.1",
    "@angular-eslint/template-parser": "^19.8.1",
    "@angular/build": "^20.3.13",
    "@angular/cli": "^20.3.13",
    "@angular/compiler-cli": "^20.3.15",
    "@angular/language-service": "^20.3.15",
    "@types/estree": "1.0.8",
    "@types/google.maps": "^3.58.1",
    "@types/jasmine": "5.1.9",
    "@types/lodash": "^4.17.15",
    "@types/node": "^22.19.2",
    "@typescript-eslint/eslint-plugin": "^8.49.0",
    "@typescript-eslint/parser": "^8.49.0",
    "@vitest/coverage-v8": "^3.2.4",
    "@vitest/ui": "^3.2.4",
    "esbuild": "0.28.0",
    "eslint": "^9.39.1",
    "eslint-config-prettier": "^10.1.8",
    "eslint-import-resolver-typescript": "^4.4.4",
    "eslint-plugin-import": "^2.32.0",
    "jasmine-core": "4.6.1",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "2.1.0",
    "karma-junit-reporter": "^2.0.1",
    "ng-packagr": "^20.3.2",
    "npm-run-all2": "^8.0.4",
    "prettier": "^3.7.4",
    "react": "17.0.2",
    "react-dom": "17.0.2",
    "rimraf": "^6.1.2",
    "terser": "^5.44.1",
    "terser-folder": "^2.0.0",
    "typescript": "~5.9.3",
    "vitest": "^3.2.4"
  }
}
